var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { reservedProps } from "../types";
import { removeKeysFromObj, retainSpecifiedKeys } from "../array.utils";
import { setPlatformName } from "../config/config-store";
import { handleError } from "../handle-error";
const createParse = () => {
    const parsePayload = (payload) => {
        // console.log('Parse payload', payload);
        let _a = payload, { platform, cache, key, action } = _a, rest = __rest(_a, ["platform", "cache", "key", "action"]);
        const customAttributes = removeKeysFromObj(rest, reservedProps);
        const parsedPayload = retainSpecifiedKeys(payload, reservedProps);
        if (platform) {
            // console.log('we have an app', platform);
            setPlatformName(platform);
        }
        // assign variable, but delete from object
        const noCache = cache === "no";
        if (noCache)
            delete rest["cache"];
        const [error, result] = handleError(() => {
            return Object.assign(Object.assign(Object.assign({}, parsedPayload), (Object.keys(customAttributes).length !== 0 && { customAttributes })), (key && { key }));
        });
        if (error) {
            console.warn("[Tracking] Error parsing meta:", error);
            return;
        }
        return result;
        // updateConfig(result);
    };
    return { parsePayload };
};
export const { parsePayload } = createParse();
// private updateConfigMap(j: { key?: string, [key: string]: any }): void {
//         // key is generated for each journey record
//         // e.g. aat('recordJourney', { key: 'celine', custom_button: 'click' });
//         let { cache, key, action, ...rest } = j;
//         // extract custom attributes
//         const customAttributes = this.clearStateProps(rest, this.reservedProperties);
//         j = this.clearCustomStateProps(j, this.reservedProperties);
//         // console.log('custom', customAttributes);
//         // console.log('j', j);
//         let noCache = cache === 'no';
//         if (noCache) delete rest['cache'];
//         // store record to map object
//         const [metaError] = handleError(() => {
//             j = {
//                 ...j, ...(Object.keys(customAttributes).length !== 0 && { customAttributes }),
//                 key: key || null,
//             };
//             // debugger;
//             if (!noCache) this.setJourneyConfig(j)
//         });
//         if (metaError) {
//             console.warn('[Tracking] Error parsing meta:', metaError)
//             return;
//         }
//     }



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/utils/parse.js
// module id = ./node_modules/@celine/passive-tracking/dist/utils/parse.js
// module chunks = 0